import {
  GlobalPermission,
  SystemPermission,
} from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/user_pb';
import { aqoraClient } from '~/services/api/aqora-client';

export const listUsers = () =>
  aqoraClient.listUsers({
    pageSize: BigInt(999999),
  });

export const linkUserToSystemsByEmail = (
  userEmail: string,
  systemPermissions: SystemPermission[],
) =>
  aqoraClient.linkUserToSystemsByEmail({
    userEmail,
    systemPermissions,
  });

export const updateUserGlobalPermissions = ({
  name,
  globalPermissions,
}: {
  name: string;
  globalPermissions: GlobalPermission[];
}) =>
  aqoraClient.updateUserGlobalPermissions({
    userName: name,
    globalPermissions,
  });
